module.exports = __webpack_public_path__ + "static/media/fan.f33d9a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/authCertificate/modules/papersUpload_GR/image/fan.png
// module id = 842
// module chunks = 0